/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([], () => {
	/**
	 * @interface DashboardSettingsAPI
	 * @hideconstructor
	 * @classdesc API interface to be implemented as a bootstrap feature in order to provide global dashboard settings
	 * @example dashboardAPI.getFeature('DashboardSettings')
	 */
	class DashboardSettingsAPI {
		/**
		 * Returns the setting corresponding to the given name
		 * @param {string} name Name of the setting
		 * @return {object} Value of the setting; undefined if the setting does not exist
		 * @example dashboardAPI.getFeature('DashboardSettings').get('fonts')
		 */
		get() {}
	}
	return DashboardSettingsAPI;
});
